import { Dimensions } from "@super-real/types";

export const calculateAspectRatio = (dimensions?: Dimensions): number => {
  return dimensions ? dimensions.width / dimensions.height : 0;
};
